import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import SchoolDataFormHandler from './components/FormHandler';

const SchoolData = () => {
  return <SchoolDataFormHandler />;
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(SchoolData)
);
